import md5 from 'md5';
import custom from '../custom';
import isEmpty from '.';

export const defPlaceCalypsoForm = (
  appInfo,
  calypsoData,
  structure,
  menu = 'tax_deduction',
) => {
  if (isEmpty(calypsoData)) return null;

  const structureItem = structure.find((item) => item.link === menu);
  if (isEmpty(structureItem)) return null;

  const calypsoForm = calypsoData.find(
    (item) => item.formUUID === structureItem.formUUID,
  );
  //console.log('calypsoForm', calypsoForm);
  if (calypsoForm.control === 'menu') {
    structureItem.hasMainMenu = true;
    appInfo.authMenuItems = [...appInfo.authMenuItems, menu];
  }
  if (calypsoForm.control === 'profile')
    structureItem.hasLeftMenu = true;
  structureItem.title = calypsoForm.title;

  structure = structure.filter((item) => item.link !== menu);

  structure.push(structureItem);

  //console.log('structure', structure);
};

export const toUpperCaseFirstLetter = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const toLowerCaseFirstLetter = (str) => {
  return str.charAt(0).toLowerCase() + str.slice(1);
};

export const transformKeysInData = (data, transformFunc) => {
  if (data === null) return null;

  if (Array.isArray(data))
    return data.map((item) =>
      transformKeysInData(item, transformFunc),
    );

  if (typeof data === 'object')
    return Object.keys(data).reduce((result, key) => {
      result[transformFunc(key)] = transformKeysInData(
        data[key],
        transformFunc,
      );
      return result;
    }, {});

  return data;
};

export const generateSign = (data, secretKey) => {
  const params = Object.keys(data)
    .sort()
    .filter((key) => key !== 'authToken')
    .map((key) => data[key])
    .filter(
      (value) => typeof value !== 'object' && value !== undefined,
    )
    .map((value) =>
      typeof value === 'boolean'
        ? toUpperCaseFirstLetter(value.toString())
        : value,
    );

  return md5(`${params.join('')}${secretKey}`).toString();
};

export const passMd5 = (pass) => md5(pass);

export const cleanPhoneValue = (value) => {
  if (value == null) return '';
  // удаляем разрешенные символы
  const cleanValue = value.replace(/[\s+()-]/gi, '');
  const numbers = cleanValue.replace(/[^\d]/gi, '');
  return '+' + numbers;
};

export const getParam = (param) => {
  const QueryString = window.location.search;
  const urlParams = new URLSearchParams(QueryString);
  return urlParams.get(param);
};

export function appInfoInit(data) {
  const appInfo = {
    ...custom,
    ...data,
  };
  const addRemove = (key, val) => {
    if (
      appInfo[key] != null &&
      appInfo[key] &&
      appInfo.authMenuItems[val] == null
    ) {
      appInfo.authMenuItems.push(val);
    }
    if (
      appInfo[key] != null &&
      !appInfo[key] &&
      appInfo.authMenuItems[val] !== null
    ) {
      appInfo.authMenuItems = appInfo.authMenuItems.filter(
        (e) => e !== val,
      );
    }
    appInfo.authMenuItems = [...new Set(appInfo.authMenuItems)];

    return appInfo;
  };

  return {
    ...addRemove('showInvoices', 'invoices'),
    ...addRemove('isDirectionsEnabled', 'directions'),
    ...addRemove('isPrescribedDrugsEnabled', 'drugs'),
    // showFastButtonsOnMainPage: true,
    // showLanguageSwitch: true,
    timeSlotsCacheDepth: parseInt(appInfo.timeSlotsCacheDepth) - 1,
  };
}
